import React from "react";
import { Gift, Plus, ShoppingCart, CheckCircle } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { GoogleS } from "@/components/BrandLogo";
import { WA_LINK } from "@/Layout";

const TSHIRT_IMG = "https://images.unsplash.com/photo-1610502778270-c5c6f4c7d575?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxibGFjayUyMHQtc2hpcnQlMjBmbGF0JTIwbGF5JTIwbW9ja3VwJTIwcGxhaW58ZW58MHx8fGJsYWNrfDE3NzUzNDYwODB8MA&ixlib=rb-4.1.0&q=85";

const LogoText = ({ size = "xs" }) => {
  const cls = size === "xs" ? "text-[7px]" : size === "sm" ? "text-[10px]" : "text-xs";
  return (
    <span className={`${cls} font-black whitespace-nowrap`} style={{ fontFamily: "'Poppins',sans-serif", WebkitTextStroke: '0.3px #000', paintOrder: 'stroke fill' }}>
      <span style={{ color: '#4285F4' }}>sch</span><span style={{ color: '#EA4335' }}>ed</span><span style={{ color: '#FBBC04' }}>abu</span><span style={{ color: '#4285F4' }}>sin</span><span style={{ color: '#34A853' }}>ess</span><span style={{ color: '#EA4335' }}>.com</span>
    </span>
  );
};

const TShirtMockupSmall = () => (
  <div className="relative w-full h-48 flex items-center justify-center">
    <div className="relative" style={{ width: '130px', height: '160px' }}>
      <div style={{ position: 'absolute', top: '36px', left: '12px', right: '12px', bottom: '0', background: 'linear-gradient(180deg, #111 0%, #000 100%)', borderRadius: '0 0 10px 10px' }}></div>
      <div style={{ position: 'absolute', top: '0', left: '-18px', right: '-18px', height: '50px', background: 'linear-gradient(180deg, #151515 0%, #000 100%)', borderRadius: '0 0 30px 30px', clipPath: 'polygon(15% 0%, 85% 0%, 100% 100%, 0% 100%)' }}></div>
      <div style={{ position: 'absolute', top: '0', left: '50%', transform: 'translateX(-50%)', width: '36px', height: '13px', background: '#000', borderRadius: '0 0 18px 18px', border: '1px solid #222', borderTop: 'none' }}></div>
      <div className="absolute flex flex-col items-center" style={{ top: '42px', left: '18px' }}>
        <GoogleS size={16} />
        <span style={{ fontSize: '3px', color: '#EA4335', fontWeight: 900 }}>.com</span>
      </div>
      <div className="absolute flex items-center justify-center" style={{ top: '64px', left: '16px', right: '16px', height: '18px' }}>
        <LogoText size="xs" />
      </div>
      <div className="absolute text-center" style={{ top: '82px', left: '16px', right: '16px' }}>
        <span style={{ fontSize: '3.5px', fontWeight: 900, color: 'white', fontStyle: 'italic', fontFamily: "'Poppins',sans-serif" }}>se non ti trovano, non esisti</span>
      </div>
      <div className="absolute flex items-center justify-center" style={{ bottom: '6px', left: '50%', transform: 'translateX(-50%)', width: '20px', height: '20px', background: 'white', borderRadius: '2px' }}>
        <span style={{ fontSize: '3px', fontWeight: 900, color: '#000', textAlign: 'center', lineHeight: 1 }}>QR</span>
      </div>
      <div className="absolute -top-2 -right-3 bg-[#34A853] text-white text-[5px] font-black px-1.5 py-0.5 rounded-full transform rotate-12">IN REGALO</div>
    </div>
  </div>
);

const PACKAGES = {
  Plus: { name: "Plus", price: "299", color: "#FBBC04", features: ["Tutto di Start incluso", "Recupero scheda sospesa", "Risposta recensioni", "Consulenza strategica 1h"] },
  Rooftop: { name: "Rooftop", price: "599", color: "#34A853", features: ["Tutto di Start + Plus", "Virtual Tour incluso", "Assistenza premium 12 mesi", "Monitoraggio competitor"] },
  "Virtual Tour": { name: "Virtual Tour", price: "499", color: "#0D9488", features: ["Pacchetto Start incluso", "Virtual Tour 360° GoPro MAX", "Timewarp IN REGALO", "15+ foto sferiche"] },
};

export const TShirtBundle = ({ pacchetto = "Plus" }) => {
  const pkg = PACKAGES[pacchetto] || PACKAGES.Plus;

  const handleOrder = () => {
    const msg = `Ciao Riccardo! Vorrei il pacchetto ${pkg.name} a €${pkg.price} con la T-Shirt schedabusiness IN REGALO! Acquistali entrambi!`;
    window.open(`${WA_LINK}?text=${encodeURIComponent(msg)}`, '_blank');
  };

  return (
    <section className="py-12 bg-[#0c1220]" data-testid="tshirt-bundle-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6">
          <Badge className="bg-[#34A853]/20 text-[#34A853] border-[#34A853]/30 mb-3 rounded-full px-4 py-1">
            <Gift className="w-4 h-4 mr-2" />
            Acquistali entrambi
          </Badge>
          <h2 className="text-2xl md:text-3xl font-bold text-white font-google">
            T-Shirt Total Black <span className="text-[#34A853]">IN REGALO</span>
          </h2>
          <p className="text-gray-400 text-sm mt-1">Con il pacchetto {pkg.name}, la T-Shirt schedabusiness e' tua!</p>
        </div>

        <div className="relative overflow-hidden rounded-2xl p-[2px]">
          <div className="absolute inset-0 bg-gradient-to-r from-[#4285F4] via-[#EA4335] via-[#FBBC04] to-[#34A853] opacity-50"></div>
          <div className="relative bg-[#0c1220] rounded-[14px] p-6 md:p-8">
            <div className="grid md:grid-cols-[1fr_auto_1fr] gap-6 items-center">
              <div className="bg-white/[0.03] border border-white/[0.08] rounded-2xl p-5 text-center">
                <div className="w-10 h-10 mx-auto mb-3 rounded-xl flex items-center justify-center" style={{ background: pkg.color }}>
                  <ShoppingCart className="w-5 h-5 text-white" />
                </div>
                <h3 className="text-white font-bold text-lg mb-1">Pacchetto {pkg.name}</h3>
                <div className="flex items-baseline justify-center gap-1 mb-3">
                  <span className="text-3xl font-black" style={{ color: pkg.color }}>€{pkg.price}</span>
                </div>
                <ul className="text-left space-y-1.5">
                  {pkg.features.map((f, i) => (
                    <li key={i} className="flex items-start gap-2 text-xs text-gray-300">
                      <CheckCircle className="w-3.5 h-3.5 flex-shrink-0 mt-0.5" style={{ color: pkg.color }} />
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="flex items-center justify-center">
                <div className="w-12 h-12 rounded-full bg-[#34A853] flex items-center justify-center shadow-lg shadow-[#34A853]/30">
                  <Plus className="w-6 h-6 text-white" />
                </div>
              </div>

              <div className="bg-white/[0.03] border border-white/[0.08] rounded-2xl p-5 text-center relative">
                <div className="absolute -top-3 right-4 bg-[#34A853] text-white text-[10px] font-black px-3 py-1 rounded-full">IN REGALO</div>
                <TShirtMockupSmall />
                <h3 className="text-white font-bold text-lg mb-1">T-Shirt Total Black</h3>
                <p className="text-gray-400 text-xs mb-2">
                  NickLogo S.com sul cuore · Logo schedabusiness.com al centro · QR code schiena
                </p>
                <div className="flex items-baseline justify-center gap-2">
                  <span className="text-xl font-black text-gray-500 line-through">€29,99</span>
                  <span className="text-xl font-black text-[#34A853]">GRATIS</span>
                </div>
              </div>
            </div>

            <div className="mt-6 pt-5 border-t border-white/10">
              <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
                <div>
                  <p className="text-white font-bold text-lg">Prezzo bundle: <span style={{ color: pkg.color }}>€{pkg.price}</span></p>
                  <p className="text-gray-400 text-xs">T-Shirt inclusa — zero costi aggiuntivi</p>
                </div>
                <button
                  onClick={handleOrder}
                  className="w-full sm:w-auto bg-[#FFD814] hover:bg-[#F7CA00] text-gray-900 font-bold py-3 px-8 rounded-full border border-[#FCD200] shadow-md transition-all active:scale-95 text-sm relative overflow-hidden group"
                  data-testid="tshirt-bundle-cta"
                >
                  <span className="relative z-10 inline-flex items-center gap-2">
                    <svg className="w-5 h-5 flex-shrink-0" viewBox="0 0 24 24" fill="none"><path d="M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944 3.72a.771.771 0 0 1 .761-.652h6.199c2.063 0 3.543.585 4.268 1.694.335.516.538 1.087.617 1.742.083.677.032 1.478-.157 2.398l-.013.063v.564l.44.249c.372.21.67.455.893.735.37.464.607 1.042.7 1.715.096.693.037 1.498-.173 2.393-.241 1.028-.635 1.922-1.171 2.655a5.292 5.292 0 0 1-1.539 1.546c-.593.39-1.298.672-2.097.84-.769.161-1.64.245-2.582.245h-.614a1.793 1.793 0 0 0-1.77 1.513l-.046.244-.77 4.88-.036.174a.164.164 0 0 1-.047.1.13.13 0 0 1-.078.028z" fill="#253B80"/><path d="M18.36 7.667a7.37 7.37 0 0 0-.078.449c-1 5.155-4.426 6.933-8.801 6.933h-2.228a1.08 1.08 0 0 0-1.07.918L5.09 22.83l-.323 2.054a.57.57 0 0 0 .563.66h3.952a.95.95 0 0 0 .94-.803l.038-.201.744-4.728.048-.26a.951.951 0 0 1 .94-.804h.591c3.83 0 6.828-1.556 7.704-6.063.366-1.882.176-3.453-.793-4.558a3.793 3.793 0 0 0-1.082-.835z" fill="#179BD7"/></svg>
                    Scegli il tuo bundle
                  </span>
                  <span className="cta-talpa-shine"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TShirtBundle;
